import {
  path,
  has,
  propEq,
  prop,
  equals,
  when,
  always,
  isNil,
  map,
  filter,
  compose,
  isEmpty,
  pluck,
  gt,
  lensProp,
  over,
  pick,
  includes,
  find,
  length,
} from 'ramda'
import { getOrDefault } from 'libs/PagingParser'

import {
  EVERYONE_TYPE,
  SUBSCRIBERS_TYPE,
  SUB_GROUP_TYPE,
  SUBSCRIBERS_NOT_IN_GROUP_TYPE,
} from 'app/constants/recipient'

import { FREQUENCY_ONCE, DEFAULT_DURATION } from 'app/constants/frequency'
import { SCOPE_BEACON } from 'app/constants/scope'

import { removeDoNotTranslateStyle } from 'commons/form'
import momentTimezone from 'moment-timezone'
import {
  FEET_ID,
  YARDS_ID,
  METERS_TEXT,
  YARDS_TEXT,
  FEET_TEXT,
  METERS_ID,
} from 'app/constants/beacon'
import { GROUP_STATUS, INDIVIDUAL_STATUS } from 'app/constants/recipient'

import {
  TWITTER_VALUE,
  LINKEDIN_VALUE,
  LINE_VALUE,
} from 'app/constants/channel'

const checkDateOrUndefined = (date, timezone) => {
  if (isNil(date) || isEmpty(date)) {
    return undefined
  }
  return momentTimezone.tz(date, timezone).utc().format()
}

const getProximityUnit = (id) => {
  switch (id) {
    case METERS_ID:
      return METERS_TEXT
    case FEET_ID:
      return FEET_TEXT
    case YARDS_ID:
      return YARDS_TEXT
    default:
      break
  }
}

const mapBeaconScheduleToApi = (formModel) => {
  if (has('beacons')(formModel)) {
    let frequencyType = getOrDefault(undefined)(() =>
      prop('frequencyType', formModel) === FREQUENCY_ONCE
        ? prop('frequencyType', formModel)
        : prop('frequencyUnit', formModel),
    )
    let duration = getOrDefault(undefined)(() =>
      prop('frequencyType', formModel) === FREQUENCY_ONCE
        ? DEFAULT_DURATION
        : prop('duration', formModel),
    )

    return {
      start_date: checkDateOrUndefined(
        formModel.scheduleStartDate,
        formModel.scheduleBeaconTimezone,
      ),
      start_timezone:
        isNil(formModel.scheduleStartDate) ||
        isEmpty(formModel.scheduleStartDate)
          ? undefined
          : formModel.scheduleBeaconTimezone,
      end_date: checkDateOrUndefined(
        formModel.scheduleEndDate,
        formModel.scheduleBeaconTimezone,
      ),
      end_timezone:
        isNil(formModel.scheduleStartDate) ||
        isEmpty(formModel.scheduleStartDate)
          ? undefined
          : formModel.scheduleBeaconTimezone,
      frequency_type: frequencyType,
      duration:
        isNil(duration) || isEmpty(duration) ? undefined : parseInt(duration),
      range: prop('range', formModel),
      proximityLength: getProximityUnit(formModel.proximityLength),
    }
  }
  return undefined
}

const mapRecipientToApi = (recipient) => {
  if (recipient) {
    const subscribers = recipient.subscribers.map((subscriber) => subscriber.id)
    return {
      entityType: gt(length(subscribers), 0) ? INDIVIDUAL_STATUS : GROUP_STATUS,
      entityIds: recipient.subGroups,
      subscriberIds: subscribers,
    }
  }
}

const mapBeaconIds = (beacons) => {
  return map((item) => item.id, beacons)
}

export const mapBeaconToApi = (formModel) => (translations) => {
  return {
    type: formModel.notiType,
    priority: formModel.priority,
    translations: map(
      over(lensProp('body'), removeDoNotTranslateStyle),
      translations,
    ),
    timezone: getOrDefault(undefined)(() => formModel.timezone),
    allowConversation: formModel.allowConversation || false,
    isTtsEnabled: formModel.isTtsEnabled || false,
    channels: formModel.channels.channelIds,
    pageIds: formModel.channels.pageIds,
    twitter: includes(TWITTER_VALUE, formModel.channels.channelIds),
    linkedin: includes(LINKEDIN_VALUE, formModel.channels.channelIds),
    line: includes(LINE_VALUE, formModel.channels.channelIds),
    ...mapRecipientToApi(formModel.recipients),
    beaconIds: mapBeaconIds(formModel.beacons),
    beaconSchedule: mapBeaconScheduleToApi(formModel),
    limitedAmount: getOrDefault(undefined)(() => formModel.limitAmount),
    scope: SCOPE_BEACON,
    isActive: Boolean(formModel.isBeaconEnabled),
    voucherId: formModel.voucher,
    mediaSocials: getOrDefault(undefined)(() =>
      map(
        pick(['url', 'isSelected', 'socialType', 'type', 'name']),
        prop('mediaSocials', formModel),
      ),
    ),
    isSharingEnabled: formModel.isSharingEnabled || false,
    displayHistory: formModel.isDisplayHistory,
    requestId: formModel.requestId,
  }
}
